import { lazy } from 'react';
import { Loadable } from './Loadable';
import { PATH_DASHBOARD } from './paths';

const smsNgRoutes = [
  {
    component: Loadable(lazy(() => import('../pages/sms-ng/EnvioIndividual'))),
    path: PATH_DASHBOARD.sms_ng.envio_individual.path,
    shouldRender: PATH_DASHBOARD.sms_ng.envio_individual.renderCondition,
  },
  {
    component: Loadable(lazy(() => import('../pages/sms-ng/EnvioMasivo'))),
    path: PATH_DASHBOARD.sms_ng.envio_masivo.path,
    shouldRender: PATH_DASHBOARD.sms_ng.envio_masivo.renderCondition,
  },
  {
    component: Loadable(lazy(() => import('../pages/sms-ng/ApiSms'))),
    path: PATH_DASHBOARD.sms_ng.api_sms.path,
    shouldRender: PATH_DASHBOARD.sms_ng.api_sms.renderCondition,
  },
  {
    component: Loadable(lazy(() => import('../pages/sms-ng/EstadoCampana'))),
    path: PATH_DASHBOARD.sms_ng.estado_campana.path,
    shouldRender: PATH_DASHBOARD.sms_ng.estado_campana.renderCondition,
  },
  {
    component: Loadable(
      lazy(() => import('../pages/sms-ng/reportes/EstadosSalientes')),
    ),
    path: PATH_DASHBOARD.sms_ng.reportes.estados_salientes.path,
    shouldRender:
      PATH_DASHBOARD.sms_ng.reportes.estados_salientes.renderCondition,
  },
  {
    component: Loadable(
      lazy(() => import('../pages/sms-ng/reportes/SmsAsociados')),
    ),
    path: PATH_DASHBOARD.sms_ng.reportes.sms_asociados.path,
    shouldRender: PATH_DASHBOARD.sms_ng.reportes.sms_asociados.renderCondition,
  },
  {
    component: Loadable(
      lazy(() => import('../pages/sms-ng/reportes/SmsSalientes')),
    ),
    path: PATH_DASHBOARD.sms_ng.reportes.sms_salientes.path,
    shouldRender: PATH_DASHBOARD.sms_ng.reportes.sms_salientes.renderCondition,
  },
  {
    component: Loadable(
      lazy(() => import('../pages/sms-ng/reportes/SmsEntrantes')),
    ),
    path: PATH_DASHBOARD.sms_ng.reportes.sms_entrantes.path,
    shouldRender: PATH_DASHBOARD.sms_ng.reportes.sms_entrantes.renderCondition,
  },
  {
    component: Loadable(
      lazy(() => import('../pages/sms-ng/reportes/ResumenPorFecha')),
    ),
    path: PATH_DASHBOARD.sms_ng.reportes.resumen_por_fecha.path,
    shouldRender:
      PATH_DASHBOARD.sms_ng.reportes.resumen_por_fecha.renderCondition,
  },
  {
    component: Loadable(
      lazy(() => import('../pages/sms-ng/reportes/ExportarSalientes')),
    ),
    path: PATH_DASHBOARD.sms_ng.reportes.exportar_salientes.path,
    shouldRender:
      PATH_DASHBOARD.sms_ng.reportes.exportar_salientes.renderCondition,
  },
  {
    component: Loadable(
      lazy(() => import('../pages/sms-ng/reportes/ExportarAsociados')),
    ),
    path: PATH_DASHBOARD.sms_ng.reportes.exportar_asociados.path,
    shouldRender:
      PATH_DASHBOARD.sms_ng.reportes.exportar_asociados.renderCondition,
  },
  {
    component: Loadable(
      lazy(() => import('../pages/sms-ng/reportes/ExportarEntrantes')),
    ),
    path: PATH_DASHBOARD.sms_ng.reportes.exportar_entrantes.path,
    shouldRender:
      PATH_DASHBOARD.sms_ng.reportes.exportar_entrantes.renderCondition,
  },
];

export default smsNgRoutes;
